const Coupon = class Coupon {
    constructor() {
        this.duration = 'once';
        this.percent_off = null;
        this.amount_off = null;
        this.currency = 'usd';
        this.duration_in_months = null;
        this.max_redemptions = null;
        this.redeem_by = null;
        this.id = '';
    }
};

export default Coupon;
